import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { submitForumClaim } from '../services/featureDb';

interface Props {
  forumId: string;
  darkMode: boolean;
}

const ForumClaimForm: React.FC<Props> = ({ forumId, darkMode }) => {
  const [email, setEmail] = useState('');
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.includes('@')) {
      toast.error('Geçerli bir e-posta adresi girin');
      return;
    }
    setSending(true);
    const { ok, error } = await submitForumClaim(forumId, email);
    setSending(false);
    if (ok) {
      toast.success('Doğrulama talebiniz alındı');
      setOpen(false);
      setEmail('');
    } else {
      toast.error(error || 'Gönderilemedi, lütfen tekrar deneyin');
    }
  };

  const input = darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-200 bg-white';

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`text-sm font-medium ${darkMode ? 'text-indigo-400 hover:text-indigo-300' : 'text-indigo-600 hover:text-indigo-800'}`}
      >
        Bu forumun sahibi misiniz?
      </button>
    );
  }

  return (
    <form
      onSubmit={submit}
      className={`mt-2 p-4 rounded-lg border max-w-md ${darkMode ? 'bg-gray-800/80 border-gray-700' : 'bg-gray-50 border-gray-200'}`}
    >
      <p className={`text-sm mb-3 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
        Sahiplik doğrulaması için iletişim e-postanızı bırakın; size dönüş yapılacaktır.
      </p>
      <div className="flex flex-wrap gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="ornek@eposta.com"
          className={`flex-1 min-w-[200px] text-sm rounded-lg border px-3 py-2 ${input}`}
        />
        <button
          type="submit"
          disabled={sending}
          className="text-sm px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50"
        >
          {sending ? 'Gönderiliyor…' : 'Talep gönder'}
        </button>
        <button
          type="button"
          onClick={() => setOpen(false)}
          className={`text-sm px-3 py-2 rounded-lg border ${darkMode ? 'border-gray-600' : 'border-gray-200'}`}
        >
          İptal
        </button>
      </div>
    </form>
  );
};

export default ForumClaimForm;
